export const downloadFile = (data, fileName) => {
    const blob = new Blob([data]);
    const url = window.URL.createObjectURL(blob);
    const a = document.createElement('a');
    a.href = url;
    a.download = `${fileName}`;
    a.click();
    a.remove();
};

export const openFileIntoNewTab = (data, fileName) => {
    const blob = new Blob([data]);
    const url = window.URL.createObjectURL(blob);
    const a = document.createElement('a');
    a.href = url;
    a.target = '_blank';
    a.click();
    a.remove();
};

export const downloadIfAttachment = (res) => {
    const disposition = res?.headers?.['content-disposition'] || '';
    if (!disposition.includes('attachment')) {
        return false;
    }
    const match = disposition.match(/filename\*?=(?:UTF-8'')?"?([^"';]+)"?/i);
    downloadFile(res.data, match ? decodeURIComponent(match[1]) : 'download');
    return true;
};

export const readAxiosData = async (data) => {
    const text = data instanceof Blob ? await data.text() : data;
    if (typeof text !== 'string') {
        return text;
    }
    try {
        return JSON.parse(text);
    } catch (e) {
        return text;
    }
};

export const toBase64 = (file) =>
    new Promise((resolve, reject) => {
        const reader = new FileReader();
        reader.readAsDataURL(file);
        reader.onload = () => resolve(reader.result);
        reader.onerror = reject;
    });

export const isValidJSON = (jsonString) => {
    if (!jsonString || !jsonString?.startsWith) {
        return false;
    }

    return jsonString.startsWith('{') || jsonString.startsWith('[') || jsonString.startsWith('<');
};

export const findErrorKey = (obj) => {
    for (let key in obj) {
        if (typeof obj[key] === 'object' && obj[key] !== null) {
            const result = findErrorKey(obj[key]);
            if (result) return result;
        } else {
            if ((key === 'error' || key === 'message' || key === 'error_description') && typeof obj[key] === 'string') {
                return obj[key];
            } else if (key === 'error' && typeof obj[key] === 'object') {
                const result = findErrorKey(obj[key]);
                if (result) return result;
            }
        }
    }
    return null;
};
